import { call, put, takeLatest } from 'redux-saga/effects'
import { toast } from 'react-toastify'
import * as types from '../../../actions/index.types'
import * as req from '../../../../axios/request/SocietyPortal/ReceiptReqs/ReceiptReqs'

function* getReceipts(action) {
    try {
        const result = yield call(req.getReceiptsReq, action)
        if (result.success === true) {
            yield put({ type: types.GET_RECEIPTS_SUCCESS, payload: result })
        } else {
            yield put({ type: types.GET_RECEIPTS_FAILURE, message: result?.message })
            toast.error(result?.message || "Failed to fetch receipts")
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.GET_RECEIPTS_FAILURE, message: e?.message })
        toast.error(e?.response?.data?.message || "Something went wrong")
    }
}

function* getReceiptDetails(action) {
    try {
        const result = yield call(req.getReceiptDetailsReq, action)
        if (result.success === true) {
            yield put({ type: types.GET_RECEIPT_DETAILS_SUCCESS, payload: result })
        } else {
            yield put({ type: types.GET_RECEIPT_DETAILS_FAILURE, message: result?.message })
            toast.error(result?.message || "Failed to fetch receipt details")
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.GET_RECEIPT_DETAILS_FAILURE, message: e?.message })
        toast.error(e?.response?.data?.message || "Something went wrong")
    }
}

function* getReceiptsByFlat(action) {
    try {
        const result = yield call(req.getReceiptsByFlatReq, action)
        if (result.success === true) {
            yield put({ type: types.GET_RECEIPTS_BY_FLAT_SUCCESS, payload: result })
        } else {
            yield put({ type: types.GET_RECEIPTS_BY_FLAT_FAILURE, message: result?.message })
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.GET_RECEIPTS_BY_FLAT_FAILURE, message: e?.message })
    }
}

function* createReceipt(action) {
    try {
        const result = yield call(req.createReceiptReq, action)
        if (result.success === true) {
            toast.success(result.message || "Receipt created successfully")
            yield put({ type: types.CREATE_RECEIPT_SUCCESS, payload: result.data })
            action?.data?.onSuccess?.()
        } else {
            yield put({ type: types.CREATE_RECEIPT_FAILURE, message: result?.message })
            toast.error(result?.message || "Failed to create receipt")
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.CREATE_RECEIPT_FAILURE, message: e?.message })
        toast.error(e?.response?.data?.message || "Something went wrong")
    }
}

function* updateReceipt(action) {
    try {
        const result = yield call(req.updateReceiptReq, action)
        if (result.success === true) {
            toast.success(result.message || "Receipt updated successfully")
            yield put({ type: types.UPDATE_RECEIPT_SUCCESS, payload: result.data })
            action?.data?.onSuccess?.()
        } else {
            yield put({ type: types.UPDATE_RECEIPT_FAILURE, message: result?.message })
            toast.error(result?.message || "Failed to update receipt")
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.UPDATE_RECEIPT_FAILURE, message: e?.message })
        toast.error(e?.response?.data?.message || "Something went wrong")
    }
}

function* deleteReceipt(action) {
    try {
        const result = yield call(req.deleteReceiptReq, action)
        if (result.success === true) {
            toast.success(result.message || "Receipt cancelled successfully")
            yield put({ type: types.DELETE_RECEIPT_SUCCESS, payload: result.data })
            action?.data?.onSuccess?.()
        } else {
            yield put({ type: types.DELETE_RECEIPT_FAILURE, message: result?.message })
            toast.error(result?.message || "Failed to cancel receipt")
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.DELETE_RECEIPT_FAILURE, message: e?.message })
        toast.error(e?.response?.data?.message || "Something went wrong")
    }
}

function* clearReceipt(action) {
    try {
        const result = yield call(req.clearReceiptReq, action)
        if (result.success === true) {
            toast.success(result.message || "Receipt cleared successfully")
            yield put({ type: types.CLEAR_RECEIPT_SUCCESS, payload: result.data })
            action?.data?.onSuccess?.()
        } else {
            yield put({ type: types.CLEAR_RECEIPT_FAILURE, message: result?.message })
            toast.error(result?.message || "Failed to clear receipt")
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.CLEAR_RECEIPT_FAILURE, message: e?.message })
        toast.error(e?.response?.data?.message || "Something went wrong")
    }
}

function* bounceReceipt(action) {
    try {
        const result = yield call(req.bounceReceiptReq, action)
        if (result.success === true) {
            toast.success(result.message || "Receipt marked as bounced")
            yield put({ type: types.BOUNCE_RECEIPT_SUCCESS, payload: result.data })
            action?.data?.onSuccess?.()
        } else {
            yield put({ type: types.BOUNCE_RECEIPT_FAILURE, message: result?.message })
            toast.error(result?.message || "Failed to bounce receipt")
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.BOUNCE_RECEIPT_FAILURE, message: e?.message })
        toast.error(e?.response?.data?.message || "Something went wrong")
    }
}

function* getOutstandingDocuments(action) {
    try {
        const result = yield call(req.getOutstandingDocumentsReq, action)
        if (result.success === true) {
            yield put({ type: types.GET_OUTSTANDING_DOCUMENTS_SUCCESS, payload: result })
        } else {
            yield put({ type: types.GET_OUTSTANDING_DOCUMENTS_FAILURE, message: result?.message })
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.GET_OUTSTANDING_DOCUMENTS_FAILURE, message: e?.message })
    }
}

function* calculateAllocationComponents(action) {
    try {
        const result = yield call(req.calculateAllocationComponentsReq, action)
        if (result.success === true) {
            yield put({ type: types.CALCULATE_ALLOCATION_COMPONENTS_SUCCESS, payload: result })
        } else {
            yield put({ type: types.CALCULATE_ALLOCATION_COMPONENTS_FAILURE, message: result?.message })
            toast.error(result?.message || "Failed to calculate components")
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.CALCULATE_ALLOCATION_COMPONENTS_FAILURE, message: e?.message })
        toast.error(e?.response?.data?.message || "Something went wrong")
    }
}

function* updateReceiptAllocations(action) {
    try {
        const result = yield call(req.updateReceiptAllocationsReq, action)
        if (result.success === true) {
            toast.success(result.message || "Allocations updated successfully")
            yield put({ type: types.UPDATE_RECEIPT_ALLOCATIONS_SUCCESS, payload: result.data })
            action?.data?.onSuccess?.()
        } else {
            yield put({ type: types.UPDATE_RECEIPT_ALLOCATIONS_FAILURE, message: result?.message })
            toast.error(result?.message || "Failed to update allocations")
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.UPDATE_RECEIPT_ALLOCATIONS_FAILURE, message: e?.message })
        toast.error(e?.response?.data?.message || "Something went wrong")
    }
}

function* bulkUploadReceipts(action) {
    try {
        const result = yield call(req.bulkUploadReceiptsReq, action)
        if (result.success === true) {
            yield put({ type: types.BULK_UPLOAD_RECEIPTS_SUCCESS, payload: result.data })
            action?.data?.onSuccess?.(result.data)
            const failed = result.data?.failed || [];
            if (failed.length === 0) {
                toast.success(result.message || "Receipts uploaded successfully")
            } else {
                toast.warn(result.message || "Upload completed with some errors")
            }
        } else {
            yield put({ type: types.BULK_UPLOAD_RECEIPTS_FAILURE, message: result?.message })
            toast.error(result?.message || "Bulk upload failed")
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.BULK_UPLOAD_RECEIPTS_FAILURE, message: e?.message })
        toast.error(e?.response?.data?.message || "Something went wrong")
    }
}

function* bulkGetReceiptDetails(action) {
    try {
        const result = yield call(req.bulkGetReceiptDetailsReq, action)
        if (result.success === true) {
            yield put({ type: types.BULK_GET_RECEIPT_DETAILS_SUCCESS, payload: result })
            action?.data?.onSuccess?.(result.data)
        } else {
            yield put({ type: types.BULK_GET_RECEIPT_DETAILS_FAILURE, message: result?.message })
            toast.error(result?.message || "Failed to fetch receipt details")
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.BULK_GET_RECEIPT_DETAILS_FAILURE, message: e?.message })
        toast.error(e?.response?.data?.message || "Something went wrong")
    }
}

function* bulkCancelReceipts(action) {
    try {
        const result = yield call(req.bulkCancelReceiptsReq, action)
        if (result.success === true) {
            toast.success(result.message || "Receipts cancelled successfully")
            yield put({ type: types.BULK_CANCEL_RECEIPTS_SUCCESS, payload: result.data })
            action?.data?.onSuccess?.(result.data)
        } else {
            yield put({ type: types.BULK_CANCEL_RECEIPTS_FAILURE, message: result?.message })
            toast.error(result?.message || "Bulk cancel failed")
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.BULK_CANCEL_RECEIPTS_FAILURE, message: e?.message })
        toast.error(e?.response?.data?.message || "Something went wrong")
    }
}

function* bulkBounceReceipts(action) {
    try {
        const result = yield call(req.bulkBounceReceiptsReq, action)
        if (result.success === true) {
            toast.success(result.message || "Receipts bounced successfully")
            yield put({ type: types.BULK_BOUNCE_RECEIPTS_SUCCESS, payload: result.data })
            action?.data?.onSuccess?.(result.data)
        } else {
            yield put({ type: types.BULK_BOUNCE_RECEIPTS_FAILURE, message: result?.message })
            toast.error(result?.message || "Bulk bounce failed")
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.BULK_BOUNCE_RECEIPTS_FAILURE, message: e?.message })
        toast.error(e?.response?.data?.message || "Something went wrong")
    }
}

function* bulkClearReceipts(action) {
    try {
        const result = yield call(req.bulkClearReceiptsReq, action)
        if (result.success === true) {
            toast.success(result.message || "Receipts cleared successfully")
            yield put({ type: types.BULK_CLEAR_RECEIPTS_SUCCESS, payload: result.data })
            action?.data?.onSuccess?.(result.data)
        } else {
            yield put({ type: types.BULK_CLEAR_RECEIPTS_FAILURE, message: result?.message })
            toast.error(result?.message || "Bulk clear failed")
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.BULK_CLEAR_RECEIPTS_FAILURE, message: e?.message })
        toast.error(e?.response?.data?.message || "Something went wrong")
    }
}

export default function* ReceiptSaga() {
    yield takeLatest(types.GET_RECEIPTS, getReceipts)
    yield takeLatest(types.GET_RECEIPT_DETAILS, getReceiptDetails)
    yield takeLatest(types.GET_RECEIPTS_BY_FLAT, getReceiptsByFlat)
    yield takeLatest(types.CREATE_RECEIPT, createReceipt)
    yield takeLatest(types.UPDATE_RECEIPT, updateReceipt)
    yield takeLatest(types.DELETE_RECEIPT, deleteReceipt)
    yield takeLatest(types.CLEAR_RECEIPT, clearReceipt)
    yield takeLatest(types.BOUNCE_RECEIPT, bounceReceipt)
    yield takeLatest(types.GET_OUTSTANDING_DOCUMENTS, getOutstandingDocuments)
    yield takeLatest(types.CALCULATE_ALLOCATION_COMPONENTS, calculateAllocationComponents)
    yield takeLatest(types.UPDATE_RECEIPT_ALLOCATIONS, updateReceiptAllocations)
    yield takeLatest(types.BULK_UPLOAD_RECEIPTS, bulkUploadReceipts)
    yield takeLatest(types.BULK_GET_RECEIPT_DETAILS, bulkGetReceiptDetails)
    yield takeLatest(types.BULK_CANCEL_RECEIPTS, bulkCancelReceipts)
    yield takeLatest(types.BULK_BOUNCE_RECEIPTS, bulkBounceReceipts)
    yield takeLatest(types.BULK_CLEAR_RECEIPTS, bulkClearReceipts)
}
